import { render } from "./LoremPicsum.vue?vue&type=template&id=14ce2fa4&scoped=true&ts=true"
import script from "./LoremPicsum.vue?vue&type=script&lang=ts"
export * from "./LoremPicsum.vue?vue&type=script&lang=ts"

import "./LoremPicsum.vue?vue&type=style&index=0&id=14ce2fa4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ce2fa4"]])

export default __exports__